var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5z",
    stroke: "#FF7534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.081c1.602 0 1.792.006 2.424.035.585.027.903.125 1.115.207.28.109.48.239.69.449.21.21.34.41.448.69.082.21.18.529.207 1.114.029.632.035.822.035 2.424 0 1.602-.006 1.792-.035 2.425-.027.584-.125.902-.207 1.114-.109.28-.239.48-.449.69-.21.21-.41.34-.69.448-.21.082-.529.18-1.114.207-.632.029-.822.035-2.424.035-1.602 0-1.792-.006-2.425-.035-.585-.027-.902-.125-1.114-.207a1.859 1.859 0 01-.69-.448 1.86 1.86 0 01-.448-.69c-.083-.212-.18-.53-.207-1.114-.029-.633-.035-.823-.035-2.425 0-1.602.006-1.792.035-2.424.027-.585.124-.903.207-1.115.108-.28.238-.48.448-.69.21-.21.41-.34.69-.448.212-.082.53-.18 1.114-.207.633-.029.823-.035 2.425-.035zm.672-1.08c1.033.002 1.263.01 1.802.035.638.03 1.075.13 1.456.279.395.153.73.359 1.063.692.333.334.539.668.692 1.063.148.381.25.818.279 1.456.029.64.036.845.036 2.474 0 1.63-.007 1.834-.036 2.474-.03.639-.13 1.075-.28 1.456-.152.395-.358.73-.691 1.063a2.942 2.942 0 01-1.063.692c-.381.148-.818.25-1.456.279-.64.03-.845.036-2.474.036-1.63 0-1.834-.007-2.474-.036-.639-.03-1.075-.13-1.456-.279a2.942 2.942 0 01-1.063-.692 2.942 2.942 0 01-.692-1.063c-.148-.381-.25-.817-.279-1.456A32.228 32.228 0 016 12.673v-1.346c.003-1.032.011-1.262.036-1.8.03-.64.13-1.076.279-1.457.153-.395.358-.73.692-1.063a2.941 2.941 0 011.063-.692c.381-.148.817-.25 1.456-.279.539-.024.769-.033 1.801-.035h1.345zm-.66 2.928a3.083 3.083 0 100 6.166 3.083 3.083 0 000-6.166zm0 1.082a2.001 2.001 0 110 4.002 2.001 2.001 0 010-4.002zm3.178-1.94a.714.714 0 100 1.429.714.714 0 000-1.429z",
    fill: "#FF7534"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7e40d581de8f720406c66c797ab91adc.svg";
export { ForwardRef as ReactComponent };